// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__NqSo-","list":"BalanceDue_list__2bkzO","listRow":"BalanceDue_listRow__2UiHJ","total":"BalanceDue_total__3zYT-"};